<template>
  <!--<top-menu />-->
  <transition name="slide-fade" mode="out-in">
    <router-view />
  </transition>
</template>

<script>
import TopMenu from "../../components/TopMenu";

export default {
  components: {
    "top-menu": TopMenu,
  },
  created() {
    //for now redirect home to achievements/list
    this.$router.push('/secure/achievements/list');
  }
};
</script>

<style>
#app,
.app__content {
  height: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}

/* Анимации появления и исчезновения могут иметь */
/* различные продолжительности и динамику.       */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active до версии 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.table-label {
  text-align:center;
  white-space:nowrap;
  display:inline-block;
  border-radius:10px;
  background-color:#7872ff;
  font-size:70%;
  margin:2px 2px 2px 0px !important;
  padding:2px 7px;
  color:#fff;
  text-transform:uppercase;
}
.table-label-blue {
  background-color:#1e87db;
}
.table-label-green {
  background-color:#449e48;
}
.table-label-grey {
  background-color:#ccc;
}
.badge {
  border-radius:10px !important;
  font-size: 70% !important;
  margin:2px 2px 2px 0px !important;
  padding:2px 7px !important;
  text-transform: uppercase;
  line-height: 1.42857143 !important;
}
</style>